import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import productData from './product/product-reducer';
import xSell from './xsell/xsell-reducer';
import compare from './compare/compare-reducer';
import userData, { StoreDataReducer } from './utility/utility-reducer';
import CartReducer from './utility/cart-reducer';
import leftMenu from './left-menu/left-menu-reducer';
import slugInfoReducer from './page/slug-info-reducer';
import redirectsReducer from './page/redirect-reducer';
import siteConfigReducer from './page/site-config-reducer';
import scriptLoaderReducer from './page/components/script-loader/script-loader-reducer';
import headerFooterReducer from './page/components/header-footer/header-footer-reducer';
import CacheReducer from './caching/cache-reducer';
import { DealReducer } from './product/components/deals';
import { PDPReducer as pdp } from './pdp';
import BlogListReducer from './blog/blog-list-reducer';
import SearchFilterReducer from './search-filter/search-filter-reducer';
import ReorderReducer from './reorder/reorder-reducer';
import UIReducer from './ui/ui-reducer';

export default history =>
    combineReducers({
        userData,
        leftMenu,
        compare,
        cartInfo: CartReducer,
        productData,
        xSell,
        slugInfo: slugInfoReducer,
        redirects: redirectsReducer,
        pdp,
        blogListInfo: BlogListReducer,
        router: connectRouter(history),
        scriptLoader: scriptLoaderReducer,
        itemCache: CacheReducer,
        deals: DealReducer,
        searchFilter: SearchFilterReducer,
        reorder: ReorderReducer,
        ui: UIReducer,
        headerFooter: headerFooterReducer,
        /** pass through reducers from server */
        testFlags: (state = {}, action) => state,
        routes: (state = [], action) => state,
        storeEnvironment: (state = process.env.NODE_ENV, action) => state,
        storeDomain: (state = '', action) => state,
        etrStoreData: StoreDataReducer,
        thirdPartyTags: (state = {}, action) => state,
        globalCustomCode: (state = {}, action) => state,
        siteConfig: siteConfigReducer,
    });
